/** Where to land after signing in: the page that bounced to /login, if any. */
export function returnPath(state: unknown): string {
  const from = (state as { from?: string } | null)?.from;
  // only same-app paths, never a protocol-relative "//host" redirect
  return from && from.startsWith("/") && !from.startsWith("//") ? from : "/boards";
}
